module.exports = __webpack_public_path__ + "static/media/1POLICY37.3ad4f1fe.jpg";